module.exports = __webpack_public_path__ + "static/media/login-bg.477450bf.svg";